import { HttpTypes } from '@/types';
import { AxiosInstance } from 'axios';

class Promotions {
  private readonly client: AxiosInstance;
  private readonly routePath = '/product/discount';

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async list(params: HttpTypes.FindParams): Promise<HttpTypes.AdminPromotionListResponse> {
    const response = await this.client.get(`${this.routePath}`, { params });
    return response.data;
  }
}

export default Promotions;
